"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.threads.title': 'Wątki',
    'whatsapp.threads.count': 'Łącznie',
    'whatsapp.threads.noThreads': 'Brak wątków.',
    'whatsapp.threads.noLogs': 'Brak logów śledzenia w tym wątku.',
    'whatsapp.threads.selectThread': 'Wybierz wątek, aby zobaczyć logi śledzenia.',
    'whatsapp.threads.showFinished': 'Pokaż zakończone',
    'whatsapp.threads.finished': 'Zakończony',
    'whatsapp.threads.finish': 'Zakończ',
    'whatsapp.threads.reopen': 'Otwórz ponownie',
    'whatsapp.threads.back': 'Wróć',
    'whatsapp.threads.confirmFinish': 'Oznaczyć ten wątek jako zakończony?',
    'whatsapp.threads.finishFailed': 'Nie udało się zakończyć wątku.',
    'whatsapp.threads.source.group': 'Grupa',
    'whatsapp.threads.source.email': 'E-mail',
    'whatsapp.threads.source.dm': 'Wiadomość bezpośrednia',
};
